module.exports = __webpack_public_path__ + "static/media/i-inst.aa171880.svg";